// The profile login just read, handed to the page the login reload opens.
//
// Login reads the user's record, then reloads into the dashboard, which read
// it again before anything else could start (team list, assessments list).
// The record is seconds old, so the dashboard takes it instead. It lives in
// this tab's sessionStorage, is used once, and only for the same email.
const KEY = "loginProfileHandoff";
const MAX_AGE_MS = 30_000;

export function handOffLoginProfile(
  email: string,
  record: Record<string, unknown>,
  now = Date.now()
): void {
  if (!email || !record) {
    return;
  }
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ email: email.toLowerCase(), at: now, record })
    );
  } catch {
    // Storage full or blocked: the dashboard reads the profile itself.
  }
}

export function takeLoginProfile(
  email: string,
  now = Date.now()
): Record<string, unknown> | null {
  let saved: { email?: unknown; at?: unknown; record?: unknown } | null = null;
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    saved = JSON.parse(raw || "null");
  } catch {
    return null;
  }
  if (
    !saved ||
    !email ||
    saved.email !== email.toLowerCase() ||
    typeof saved.at !== "number" ||
    now - saved.at < 0 ||
    now - saved.at >= MAX_AGE_MS ||
    !saved.record ||
    typeof saved.record !== "object"
  ) {
    return null;
  }
  return saved.record as Record<string, unknown>;
}
